import { Button, Modal } from 'components/core';
import { FC } from 'react';
import { IoCloseCircleOutline } from 'react-icons/io5';
import { Styled, IteroOrderErrorModalProps } from '.';
import { useI18n } from '../../contexts/i18n';

export const IteroOrderErrorModal: FC<IteroOrderErrorModalProps> = ({
  onClose,
  
}) => {
  const i18n = useI18n();
  return (
    <Modal>
      <Styled.ErrorContainer>
        <IoCloseCircleOutline size="72px" style={{ color: '#c73e1d' }} />
        <Styled.ErrorTitle>{i18n['Order Failed!']}</Styled.ErrorTitle>
        <Styled.ErrorMessage>
          {i18n['Oops! An error occoured while placing the order.']} <br />
          {i18n['You can try again or contact our support team.']}
        </Styled.ErrorMessage>
        <Button size="sm" onClick={onClose}>
          {i18n['Close']}
        </Button>
      </Styled.ErrorContainer>
    </Modal>
  );
};
